import React, { useCallback, useMemo } from 'react';
import { draw } from 'actions/cards';
import { withDeckRefreshContext } from 'components/DeckRefreshContext';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IAppState } from 'types/app';

import SmallDeckComponent from './SmallDeckComponent';

type Props = ReturnType<typeof mapStateToProps> & {
  dispatch: Function,
  onOpenDeckRefreshModal: () => void,
}

function SmallDeckContainer(props: Props) {
  const {
    cardsCount,
    dispatch,
    displayCards,
    isFetching,
    handSize,
    onOpenDeckRefreshModal,
  } = props;

  const handFull = useMemo(() => displayCards && displayCards.length === handSize, [displayCards, handSize]);
  const noCards = useMemo(() => cardsCount === 0, [cardsCount]);

  const handleClick = useCallback(() => {
    // If we are out of cards, prompt the user to buy more with Fate
    if (cardsCount === 0) {
      onOpenDeckRefreshModal();
    }

    // If we have no empty slots in our hand, don't do anything
    if (displayCards.length === handSize) {
      return null;
    }

    // Otherwise, draw a card
    return dispatch(draw());
  }, [
    cardsCount,
    dispatch,
    displayCards.length,
    handSize,
    onOpenDeckRefreshModal,
  ]);

  return (
    <SmallDeckComponent
      handFull={handFull}
      isFetching={isFetching}
      noCards={noCards}
      onClick={handleClick}
    />
  );
}

SmallDeckContainer.displayName = 'SmallDeckContainer';

const mapStateToProps = ({
  cards: {
    cardsCount,
    displayCards,
    handSize,
    isFetching,
  },
  fate: { data: fateData },
}: IAppState) => ({
  cardsCount,
  displayCards,
  fateData,
  handSize,
  isFetching,
});

export default withRouter(connect(mapStateToProps)(withDeckRefreshContext(SmallDeckContainer)));